{
  "titles": {
    "menu": "Dashboard",
    "page": "Dashboard",
    "fundingStatistics": "Spaardeposito's",
    "financeReceiverStatistics": "Uitgaande financieringen"
  },
  "dashboardItems": {
    "funderCount": "Spaarders",
    "averageAmountPerContract": "Gemiddeld per contract",
    "activeFunders": "Actieve spaarders",
    "inactiveFunders": "Inactieve spaarders",
    "totalActiveAmount": "Totaal",
    "totalInterestCosts": "Rente kosten",
    "totalPartnerCosts": "Partner kosten",
    "deviationInterestCost": "Afwijking rente kosten",
    "totalNewAmount": "Nieuw deze maand",
    "totalRenewedAmount": "Verlengd deze maand",
    "totalIncomingAmount": "Nieuw deze maand",
    "totalOutgoingAmount": "Uit deze maand",
    "activeContracts": "Actieve contracten"
  },
  "reports": {
    "fundingContractCashflow": "Spaarders kasstroom",
    "fundingContractVariantRatio": "Variant verhoudingen",
    "funderCount": "Spaarders"
  },
  "financeReceiverStatistics": {
    "revenueCurrentWeek": "Omzet deze week",
    "revenueFinancingCosts": "Financieringskosten",
    "revenueAdministrationCosts": "Administratiekosten",
    "revenuePenalties": "Achterstallige rente",
    "revenueTreatmentFee": "Behandelingskosten",
    "revenueTotalAmount": "Totaal omzet deze week"
  },
  "messages": {
    "lastMonth": "Vorige maand: {amount}",
    "lastWeek": "Vorige week: {amount}",
    "thisWeek": "Deze week",
    "confirmed": "Bevestigd: {amount}",
    "expected": "Verwacht: {amount}"
  },
  "taskTypes": {
    "PaymentBatchApproval": "Rente en fee moeten uitbetaald worden",
    "FundingContractEnding": "Contracten te verlengen"
  }
}


